import React from 'react';

export const EventsSkeleton = () => {
  return (
    <div className="animate-pulse">
      <div className="flex flex-col flex-wrap gap-8">
        <div className="flex flex-col w-full">
          <div className="flex justify-between items-center gap-2 py-4 px-0">
            <div className="w-full max-w-[300px] h-9 rounded-[36px] bg-mbgray-100"></div>
          </div>
          <div className="flex gap-4 overflow-hidden">
            <div className="w-1/2 rounded-[36px] bg-mbgray-100 aspect-video"></div>
            <div className="w-1/2 rounded-[36px] bg-mbgray-100 aspect-video"></div>
          </div>
        </div>
        <div className="flex flex-col w-full">
          <div className="flex justify-between items-center gap-2 pt-4 pb-5 px-0">
            <div className="w-full max-w-[300px] h-9 rounded-[36px] bg-mbgray-100"></div>
          </div>
          <div className="flex gap-4 overflow-hidden">
            <div className="w-1/4 h-auto rounded-[36px] bg-mbgray-100 aspect-video"></div>
            <div className="w-1/4 h-auto rounded-[36px] bg-mbgray-100 aspect-video"></div>
            <div className="w-1/4 h-auto rounded-[36px] bg-mbgray-100 aspect-video"></div>
            <div className="w-1/4 h-auto rounded-[36px] bg-mbgray-100 aspect-video"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
